import { runJsonGet } from '@/backend-client'
import { OPERATIONS_BACKEND_URL } from '@/config'

import { transformKeysToCamelCase } from './utils/casing'
import {
  OrderEntity,
  NextLoadSuggestionsSortBy,
  SuggestedBaseCostResponse
} from './models/marketplace-service-model'

/**
 * @param {number} orderId
 * @param {number} size
 * @param {NextLoadSuggestionsSortBy} sortBy
 * @returns {Promise<NextLoadSuggestions>}
 */
export const fetchNextLoadSuggestions = async (
  orderId: number,
  sortBy: NextLoadSuggestionsSortBy = NextLoadSuggestionsSortBy.Nearest,
  size = 5
): Promise<Array<OrderEntity>> => {
  const { data } = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/marketplace/orders/${orderId}/next-suggestions?size=${size}&sort_by=${sortBy}`
  )

  return transformKeysToCamelCase(data.next_suggested_orders)
}

/**
 * @param {number} orderId
 * @returns {Promise<SuggestedBaseCostResponse>}
 */
export const fetchSuggestedCost = async (
  orderId: number
): Promise<SuggestedBaseCostResponse> => {
  const { data } = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/ordering/queries/get-carrier-suggested-cost/${orderId}`
  )
  return transformKeysToCamelCase(data)
}
